/**
 * Function to ensure only one active function call is made. Ensure the callback function returns Promise<void>
 */
export function ensureSingleRequest<TCB extends (...args: any[]) => Promise<void>>(callback: TCB, context=null) {
    let shouldWait = false;
    return (async (...executionParams: any[]) => {
        if (shouldWait) {
            return;
        }
        shouldWait = true;
        await callback.apply(context, executionParams);
        shouldWait = false;
    }) as TCB;
}